module.exports = __webpack_public_path__ + "media/src/images/corp-certified-sample-f65cc89d311ac1a9357c4c4c288054ba.jpg";